import * as React from "react"

const Share = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" {...props}>
    <path d="M448 128c0 53-43 96-96 96-28.9 0-54.8-12.8-72.4-33l-89.7 44.9c1.4 6.5 1.2 13.2 1.2 19.2 0 7.8.2 14.5-1.2 21l89.7 44c17.6-19.3 43.5-33 72.4-33 53 0 96 43 96 96.9 0 53-43 96-96 96-53.9 0-96-43-96-96 0-6.9.7-13.6 2.1-20.1L168.4 319c-17.6 20.2-43.5 33-72.4 33-53.02 0-96-43-96-96.9 0-53 42.98-96 96-96 28.9 0 54.8 13.7 72.4 33l89.7-44c-1.4-6.5-2.1-13.2-2.1-20.1 0-53.02 42.1-96 96-96 53 0 96 42.98 96 96zM95.1 304c27.4 0 48-21.5 48-48s-20.6-48-48-48c-25.61 0-48 21.5-48 48s22.39 48 48 48zM352 80c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 352c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48z" />
  </svg>
)

export default Share
